import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BirthdayFilters = ({ 
  filters = {}, 
  onFiltersChange, 
  onExport,
  contactGroups = [],
  className = '' 
}) => {
  const timeframeOptions = [
    { value: 'all', label: 'All Time' },
    { value: 'thisMonth', label: 'This Month' },
    { value: 'nextMonth', label: 'Next Month' },
    { value: 'next7Days', label: 'Next 7 Days' },
    { value: 'next30Days', label: 'Next 30 Days' },
    { value: 'thisQuarter', label: 'This Quarter' }
  ];

  const groupOptions = [
    { value: 'all', label: 'All Groups' },
    ...contactGroups?.map(group => ({
      value: group?.id,
      label: group?.name
    }))
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'pending', label: 'Pending' },
    { value: 'sent', label: 'Sent' },
    { value: 'scheduled', label: 'Scheduled' },
    { value: 'failed', label: 'Failed' }
  ];

  const handleFilterChange = (key, value) => {
    onFiltersChange({
      ...filters,
      [key]: value
    });
  };

  const clearFilters = () => {
    onFiltersChange({
      timeframe: 'all',
      group: 'all',
      status: 'all'
    });
  };

  const hasActiveFilters = Object.values(filters)?.some(value => value && value !== 'all');

  return (
    <div className={`bg-surface rounded-lg border border-border shadow-card p-4 lg:p-6 ${className}`}>
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
        {/* Filter Controls */}
        <div className="flex flex-col sm:flex-row gap-4 flex-1">
          <div className="flex-1 min-w-[200px]">
            <Select
              label="Timeframe"
              options={timeframeOptions}
              value={filters?.timeframe || 'all'}
              onChange={(value) => handleFilterChange('timeframe', value)}
              className="w-full"
            />
          </div>

          <div className="flex-1 min-w-[200px]">
            <Select
              label="Contact Group"
              options={groupOptions}
              value={filters?.group || 'all'}
              onChange={(value) => handleFilterChange('group', value)}
              className="w-full"
            />
          </div>

          <div className="flex-1 min-w-[200px]">
            <Select
              label="Message Status"
              options={statusOptions}
              value={filters?.status || 'all'}
              onChange={(value) => handleFilterChange('status', value)}
              className="w-full"
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center space-x-2">
          {hasActiveFilters && (
            <Button
              variant="outline"
              size="sm"
              onClick={clearFilters}
              iconName="X"
              iconPosition="left"
            >
              Clear
            </Button>
          )}

          <Button
            variant="outline"
            size="sm"
            onClick={onExport}
            iconName="Download"
            iconPosition="left"
          >
            Export
          </Button>
        </div>
      </div>
      {/* Active Filters Display */}
      {hasActiveFilters && (
        <div className="flex flex-wrap items-center gap-2 mt-4 pt-4 border-t border-border">
          <span className="text-sm text-text-secondary">Active filters:</span>
          
          {Object.entries(filters)?.map(([key, value]) => {
            if (!value || value === 'all') return null;
            
            const getFilterLabel = () => {
              switch (key) {
                case 'timeframe':
                  return timeframeOptions?.find(opt => opt?.value === value)?.label || value;
                case 'group':
                  return groupOptions?.find(opt => opt?.value === value)?.label || value;
                case 'status':
                  return statusOptions?.find(opt => opt?.value === value)?.label || value;
                default:
                  return value;
              }
            };

            return (
              <span
                key={key}
                className="inline-flex items-center space-x-1 bg-primary/10 text-primary text-sm px-2 py-1 rounded-full"
              >
                <span>{getFilterLabel()}</span>
                <button
                  onClick={() => handleFilterChange(key, 'all')}
                  className="hover:bg-primary/20 rounded-full p-0.5 transition-micro"
                >
                  <Icon name="X" size={12} />
                </button>
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default BirthdayFilters;